
import React from 'react';
import { Droplet } from 'lucide-react';

const WaterQuality = () => {
  return (
    <div className="h-full flex items-center justify-center">
      <div className="p-4 flex flex-col items-center justify-center h-full w-full">
        <h3 className="text-lg font-medium text-gray-800 dark:text-white mb-2">Water Quality</h3>
        <div className="mb-2">
          <Droplet className="h-7 w-7 text-blue-500 mb-2" />
        </div>
        <p className="text-xl font-bold text-blue-500 mb-2">98.2%</p>
        <p className="text-xs text-green-400">↑ 0.3% from last month</p>
        <p className="text-xs text-gray-500 dark:text-gray-300 mt-1">Based on purity tests</p>
      </div>
    </div>
  );
};

export default WaterQuality;
